import { render, staticRenderFns } from "./catalogueSelect.vue?vue&type=template&id=02f24cb7&scoped=true"
import script from "./catalogueSelect.vue?vue&type=script&lang=js"
export * from "./catalogueSelect.vue?vue&type=script&lang=js"
import style0 from "./catalogueSelect.vue?vue&type=style&index=0&id=02f24cb7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02f24cb7",
  null
  
)

export default component.exports